import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

@Injectable()
export class AppSettings {

    public static get build() { return 54; }
    public static get version() { return '1.6.7'; }
    public static get buildDate() { return 'Sep 24, 2026'; }

    public static get isProduction() { return environment.production; }
    public static get gtmId() { return environment.gtmId; }
    public static get apiURL() { return environment.apiURL; }
    public static get hubURL() { return environment.hubURL; }
    public static get clientURL() { return environment.clientURL; }
    public static get cbsDashUrl() { return environment.cbsDashUrl; }
    public static get cbsAPIUrl() { return environment.cbsAPIUrl; }
    public static get bbClientUrl() { return environment.bbClientUrl; }
}